import { render, staticRenderFns } from "./shopInformationCollect.vue?vue&type=template&id=472fbf7c&scoped=true"
import script from "./shopInformationCollect.vue?vue&type=script&lang=ts"
export * from "./shopInformationCollect.vue?vue&type=script&lang=ts"
import style0 from "./shopInformationCollect.vue?vue&type=style&index=0&id=472fbf7c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472fbf7c",
  null
  
)

export default component.exports